import { Options } from "./types";
import { Rank } from "../user/types";
import { getRankName, getRanks } from "../user/rank";
import { genOption } from "./helpers";

export const rankOptions: Options<Rank> = getRanks().map(
  genOption(getRankName)
);
